import axios from 'axios';

let baseURL = process.env.baseURL || "https://djmachadoapp.com/djmachadoapp/api";

let instance = axios.create({
	baseURL
});

export const HTTP = instance;